import styled from '@emotion/styled'
import List from '../../List'

export const Bullets = styled(List)`
  * {
    color: ${({ theme }) =>
      `${theme?.components?.PackageCard?.color || 'black'} !important`};
  }

  li {
    &:last-child {
      margin-bottom: 0;
    }
  }
`
